import React from "react";

const RoomListWrapperMember = ({
  chatRooms,
  loading,
  onSelectMember,
  selectedRoom,
  addGroupMemberSearch,
  groupMember,
}) => {
  const currentUserId = window.localStorage.getItem("userid");
  const uniqueChatRooms = [...new Set([...chatRooms])];

  if (loading) {
    return <span>Loading...</span>;
  }

  if (!uniqueChatRooms.length) {
    return <span>No users found!</span>;
  }

  const filteredRooms = uniqueChatRooms
    .filter(
      (room) => !groupMember.some((member) => room.userid === member.userid)
    )
    .filter((room) => {
      const fullName = `${room.firstname} ${room.lastname}`.toLowerCase();
      const searchQuery = addGroupMemberSearch.toLowerCase();
      return (
        fullName?.includes(searchQuery) ||
        room?.firstname?.toLowerCase()?.includes(searchQuery) ||
        room?.lastname?.toLowerCase()?.includes(searchQuery)
      );
    })
    .filter((room) => room.userid !== currentUserId);

  return filteredRooms.map((room, index) => (
    <div
      key={`room-${index}`}
      className={`single-person ${
        selectedRoom && room.groupid === selectedRoom.groupid ? "c02A29B" : ""
      }`}
      style={{ paddingInline: "20px" }}
      onClick={() => onSelectMember(room)}
    >
      <div className="single-person-grid2">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            position: "relative",
          }}
        >
          <div
            className="name-image-style temp-image-style"
            style={{ height: "44px", width: "44px" }}
          >
            {room?.imageurl ? (
              <img
                src={room.imageurl}
                alt="user"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "100%",
                }}
              />
            ) : (
              <div
                style={{
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#FFFFFF",
                  fontSize: "14px",
                  fontWeight: "700",
                  background: "#95A7C6",
                }}
              >
                {`${room?.firstname[0]?.toUpperCase()}${
                  room?.lastname
                    ? room?.lastname[0]?.toUpperCase()
                    : room?.firstname[1]?.toUpperCase()
                }`}
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "start",
          }}
        >
          <span
            className="name-style"
            style={{
              fontSize: "14px",
              color: "#333333",
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            {`${room?.firstname} ${room?.lastname}`}
          </span>
        </div>
      </div>
    </div>
  ));
};

export default RoomListWrapperMember;
